import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import {StyledProps} from "../StyledProps";
import {SwipeableDrawer} from "@material-ui/core";
import "./sidebar.scss";
import SidebarContent from "./content/SidebarContent";
import {Area} from "../../repositories/area/Area";
import {Repositories} from "../../repositories/Repositories";

interface SidebarProps {
    show: boolean,
    toggle: () => void,
    onAreaSelected: (area: Area) => void,
    resetView: () => void
}

const Sidebar: FunctionComponent<SidebarProps & StyledProps> = (
    {
        show,
        toggle,
        onAreaSelected,
        resetView
    }
) => {
    const [areas, setAreas] = useState<Area[]>([]);

    useEffect(() => {
        Repositories.area.fetchAreas()
            .then((areas: Area[]) => setAreas(areas));
    }, []);

    return (
        <React.Fragment key={'left'}>
            <SwipeableDrawer
                anchor={'left'}
                open={show || false}
                onOpen={() => toggle()}
                onClose={() => toggle()}
                className={'sidebar'}
            >
                <SidebarContent
                    toggle={toggle}
                    areas={areas}
                    onAreaSelected={onAreaSelected}
                    resetView={resetView}
                />
            </SwipeableDrawer>
        </React.Fragment>
    );
}

export default Sidebar;
